import cancelEvent from '@helpers/dom/cancelEvent';

export default function lockTouchScroll(container: HTMLElement) {
  const onTouchMove = (e: TouchEvent) => {
    cancelEvent(e);
  };

  let lockers = 2;
  const cb = () => {
    if(!--lockers) {
      container.removeEventListener('touchmove', onTouchMove, {capture: true});
    }
  };

  container.addEventListener('touchmove', onTouchMove, {capture: true, passive: false});
  container.addEventListener('touchend', cb, {once: true});

  return cb;
}
